
import { computed, defineComponent, provide } from "vue";
import { DASHBOARD_MOVE_CONTROLS_KEY } from "@/utils/dashboardLayout";

export default defineComponent({
  name: "DashboardMovableBlock",
  props: {
    label: { type: String, default: "" },
    canMoveUp: { type: Boolean, default: true },
    canMoveDown: { type: Boolean, default: true },
  },
  emits: ["move-up", "move-down"],
  setup(props, { emit }) {
    provide(DASHBOARD_MOVE_CONTROLS_KEY, {
      canMoveUp: computed(() => props.canMoveUp),
      canMoveDown: computed(() => props.canMoveDown),
      moveUp: () => emit("move-up"),
      moveDown: () => emit("move-down"),
    });
  },
});
